import { render, staticRenderFns } from "./Notificationform.vue?vue&type=template&id=490b30f8&scoped=true"
import script from "./Notificationform.vue?vue&type=script&lang=js"
export * from "./Notificationform.vue?vue&type=script&lang=js"
import style0 from "./Notificationform.vue?vue&type=style&index=0&id=490b30f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b30f8",
  null
  
)

export default component.exports